module.exports = __webpack_public_path__ + "img/share-twiter-normal.680e253a.svg";